<script setup lang="ts">
import { ref, watch, computed, onBeforeUnmount } from 'vue'
import type Odd from '@src/models/Odd'
import { APP_LANG, MAXIMUM_ODD_FRACTION_DIGITS, MINIMUM_ODD_FRACTION_DIGITS, ODD_CHANGE_TRACKER_TIMEOUT } from '@src/constants/constants'
import ConfigService from '@src/services/config/ConfigService';

const props = defineProps<{
    odd: Odd
}>()

const oddChangeClass = ref('')
let oddChangedTimer: NodeJS.Timeout | null = null

const setOddChangeClass = (value: string) => {
    oddChangeClass.value = value
}

const oddDisplayValue = computed(() => {
    if (props.odd.isBlocked) {
        setOddChangeClass('')

        return '-'
    }

    const maximumFractionDigits = ConfigService.getConfig().flags.isThreeDecimalPointsEnabled ? MAXIMUM_ODD_FRACTION_DIGITS : MINIMUM_ODD_FRACTION_DIGITS;

    return props.odd.value.toLocaleString(APP_LANG, { maximumFractionDigits, minimumFractionDigits: MINIMUM_ODD_FRACTION_DIGITS })
})

watch(
    () => props.odd.value,
    (newValue, oldValue) => {
        if (oldValue !== newValue) {
            const oddChangedClass = oldValue > newValue ? 'down' : 'up'

            setOddChangeClass(oddChangedClass)
            oddChangedTimer = setTimeout(() => setOddChangeClass(''), ODD_CHANGE_TRACKER_TIMEOUT)
        }
    }
)

onBeforeUnmount(() => {
    if (oddChangedTimer) {
        clearTimeout(oddChangeClass.value)
    }
})
</script>

<template>
    <span :class="['odd', oddChangeClass && `odd--${oddChangeClass}`]">
        {{ oddDisplayValue }}
        <i :class="`superbet-icon icon-chevron_${oddChangeClass}_right`" />
    </span>
</template>

<style lang="scss" scoped>
.superbet-icon {
    font-size: $font-size-s;
    position: absolute;
}

.icon-chevron_down_right {
    bottom: -$space-s;
}

.icon-chevron_up_right {
    top: -$space-s;
}
</style>
